<div class="ui-g-12">

  <div class="ui-g">
    <div *ngFor="let indicator of indicators" class="ui-g-12 ui-md-3 ui-sm-6">
        <app-infobox [pointData]="indicator.pointData" [penetration]="indicator.penetration" [t]="indicator.t" [options]="indicator.options"></app-infobox>
    </div>
  </div>

  <div class="campaigncharts" *ngIf="filterApplied">
    <div class="ui-g">
      <div class="ui-g-12 ui-md-12 ui-sm-12">
        <h2>{{ translations.chart_title }}</h2>
      </div>
      <div class="ui-g-12 ui-md-6 ui-sm-12">
        <div class="chart-container">
          <chart [options]="leftChart.options"
                 (load)="setChartInstance(leftChart, $event.context)"></chart>
        </div>
      </div>

      <div class="ui-g-12 ui-md-6 ui-sm-12">
        <p-dataTable [value]="datatable" class="overview-table">

          <p-headerColumnGroup>
            <p-row>
              <p-column [styleClass]="'border-right'" header="" ></p-column>
              <p-column [styleClass]="'border-right'" header="{{ translations.chart_points }}" colspan="3"></p-column>
              <p-column header="{{ translations.chart_erogation }}" colspan="3"></p-column>
            </p-row>
            <p-row>
              <p-column [styleClass]="'border-right'" header="{{ translations.chart_mechanics }}"></p-column>
              <p-column header="{{ translations.chart_current }}"></p-column>
              <p-column header="{{ translations.chart_previous }}"></p-column>
              <p-column [styleClass]="'border-right'" header="{{ translations.chart_delta }}"></p-column>
              <p-column header="{{ translations.chart_current }}"></p-column>
              <p-column header="{{ translations.chart_previous }}"></p-column>
              <p-column header="{{ translations.chart_delta }}"></p-column>
            </p-row>
          </p-headerColumnGroup>

          <p-column [styleClass]="'border-right'" field="meccanica"></p-column>
          <p-column [styleClass]="'number-column'">
            <ng-template let-col="rowData" pTemplate type="body">
              {{ col.pt_corr | formatNumber }}
            </ng-template>
          </p-column>
          <p-column [styleClass]="'number-column'">
            <ng-template let-col="rowData" pTemplate type="body">
              {{ col.pt_prec | formatNumber }}
            </ng-template>
          </p-column>
          <p-column [styleClass]="'border-right number-column delta-row ' + (+sumRow.erog_delta < 0 ? 'delta-negative' : '')">
            <ng-template let-col="rowData" pTemplate type="body">
              {{ col.pt_delta == 'Infinity' ? '-' : (col.pt_delta | formatNumber:2) + '%' }}
            </ng-template>
          </p-column>
          <p-column [styleClass]="'number-column'">
            <ng-template let-col="rowData" pTemplate type="body">
              {{ col.erog_corr | formatNumber }}
            </ng-template>
          </p-column>
          <p-column [styleClass]="'number-column'">
            <ng-template let-col="rowData" pTemplate type="body">
              {{ col.erog_prec | formatNumber }}
            </ng-template>
          </p-column>
          <p-column [styleClass]="'number-column delta-row ' + (+sumRow.erog_delta < 0 ? 'delta-negative' : '')">
            <ng-template let-col="rowData" pTemplate type="body">
              {{ col.erog_delta == 'Infinity' ? '-' : (col.erog_delta | formatNumber:2) + '%' }}
            </ng-template>
          </p-column>

          <p-footerColumnGroup>
            <p-row>
              <p-column footer="{{ sumRow.meccanica | translate }}"></p-column>
              <p-column [styleClass]="'number-column'" footer="{{ sumRow.pt_corr | formatNumber }}"></p-column>
              <p-column [styleClass]="'number-column'" footer="{{ sumRow.pt_prec | formatNumber }}"></p-column>
              <p-column [styleClass]="'number-column delta-row ' + (+sumRow.pt_delta < 0 ? 'delta-negative' : '')" footer="{{ sumRow.pt_delta == 'Infinity' ? '-' : (sumRow.pt_delta | formatNumber:2) + '%' }}"></p-column>
              <p-column [styleClass]="'number-column'" footer="{{ sumRow.erog_corr | formatNumber }}"></p-column>
              <p-column [styleClass]="'number-column'" footer="{{ sumRow.erog_prec | formatNumber }}"></p-column>
              <p-column [styleClass]="'number-column delta-row ' + (+sumRow.erog_delta < 0 ? 'delta-negative' : '')" footer="{{ sumRow.erog_delta == 'Infinity' ? '-' : (sumRow.erog_delta | formatNumber:2) + '%' }}"></p-column>
            </p-row>
          </p-footerColumnGroup>

        </p-dataTable>
      </div>
    </div>
  </div>


</div>



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customers-points/customer-points-redemption/customer-points-redemption.component.html